import React from 'react';
import { cn } from '@/helpers/utils';
import { Link } from '@americanexpress/dls-react';

import { ChefProfile, Profile } from '../interface';
import styles from './Partner.module.scss';

interface PartnerProps {
  partner: ChefProfile | Profile;
  anchorId?: string;
}

const Partner: React.FC<PartnerProps> = ({ partner, anchorId }) => {
  const {
    bio,
    exampleImage,
    exampleImageAltText,
    exampleImageFootnote,
    name,
    profileImage,
    profileImageAltText,
    profileImageFootnote,
    quote,
    resyButtonText,
    resyButtonUrl,
    signatureImage,
    signatureImageAltText,
  } = partner;

  return (
    <div
      className="tw-col-span-8 tw-grid tw-grid-cols-1 tw-gap-y-10 md_tw-gap-y-16 lg_tw-grid-cols-8"
      id={anchorId}
    >
      <div className="flex tw-col-span-6 tw-col-start-2 tw-flex-col tw-gap-y-2">
        <div className="color-text-emphasis tw-font-bold">{name}</div>
        <div dangerouslySetInnerHTML={{ __html: bio }} />
        <div className="margin-1-b">
          <Link
            className="tw-font-sans tw-font-medium tw-text-blue-bright-shade-600-s8"
            href={resyButtonUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {`${resyButtonText} Resy`}
          </Link>
        </div>
      </div>

      <div className="tw-col-span-8 tw-grid tw-gap-y-10 md_tw-gap-y-16">
        <div className="flex tw-flex-wrap tw-gap-y-10 md_tw-flex-nowrap md_tw-gap-x-6">
          <div className="md_tw-flex-1">
            <img
              className="tw-rounded-2xl"
              src={profileImage}
              alt={profileImageAltText}
            />
            {profileImageFootnote && (
              <div className="text-align-center margin-2-t color-text-subtle">
                {profileImageFootnote}
              </div>
            )}
          </div>
          <div className="md_tw-flex-1">
            <img
              className="tw-rounded-2xl"
              src={exampleImage}
              alt={exampleImageAltText}
            />
            {exampleImageFootnote && (
              <div className="text-align-center margin-2-t color-text-subtle">
                {exampleImageFootnote}
              </div>
            )}
          </div>
        </div>
        <div className="text-align-center color-text-subtle tw-font-serif tw-text-2xl md_tw-text-5xl">
          <p>&ldquo;{quote}&rdquo;</p>
        </div>
        <div className={cn('flex tw-justify-center', styles.signature)}>
          <img src={signatureImage} alt={signatureImageAltText} />
        </div>
      </div>
    </div>
  );
};

export default Partner;
